var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { Button } from "./..";
var StyledButton = styled(Button)(function (_a) {
    var theme = _a.theme;
    return "\n:not([disabled]):hover {\n  text-decoration: none;\n  color: " + theme.colors.secondary500 + "\n}";
});
export var DropdownItemButton = function (_a) {
    var children = _a.children, id = _a.id, props = __rest(_a, ["children", "id"]);
    return (React.createElement(StyledButton, __assign({ id: id, emphasis: "low", palette: "primary" }, props, { lss: __assign({ textAlign: 'left', width: '100%', whiteSpace: 'nowrap', ':focus': {
                outline: 'none',
                textDecoration: 'none'
            } }, props.lss) }), children));
};
//# sourceMappingURL=DropdownItemButton.js.map